import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import BillingDetailsCard from '@/shared-components/payment-profile/BillingDetailsCard';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

function resolveBillingAddress(profile) {
  const address = profile?.auction_bidder_profile?.billing_address ?? {};
  return [address.address_street, address.address_zip_code, address.address_city, address.address_region]
    .filter(Boolean)
    .join(', ') || 'Not provided';
}

export default function BusinessBillingDialog({
  target,
  onClose,
  profile,
  error,
  successMessage,
  needsDetails,
  onDetailsSaved,
  loading,
  onConfirm,
}) {
  const billingInfo = profile?.auction_bidder_profile?.billing_info ?? {};
  const billingAddress = profile?.auction_bidder_profile?.billing_address ?? {};
  const vatId = billingInfo.vat_id || 'Not provided';
  const vatStatus = billingInfo.vat_id ? (billingInfo.vat_valid === true ? ' (verified)' : ' (not verified)') : '';

  return (
    <GenericPopup open={Boolean(target)} onBackgroundClick={onClose} opacity className="generic-popup_content profile-payments__popup">
      <div className="generic-popup__header profile-payments__popup-header">
        <Text className="generic-popup__header-text profile-payments__popup-title ">Buy as business</Text>
        <XIcon className="generic-popup__close profile-payments__popup-close" onClick={onClose} />
      </div>
      <div className="profile-payments__invoice-body">
        <Text className="">Confirm your billing details. We will update your subscription for business invoicing.</Text>
        <Text className="profile-payments__invoice-message ">No immediate charge. The updated amount applies on the next renewal date.</Text>
        {error && <Text className="profile-payments__invoice-message ">{error}</Text>}
        {successMessage && <Text className="profile-payments__invoice-message ">{successMessage}</Text>}
        {!needsDetails && (
          <div className="profile-payments__summary-cancellation">
            <Text className="">Legal name: <span className="profile-payments__billing-value">{billingInfo.legal_name || billingInfo.company_name || 'Not provided'}</span></Text>
            <Text className="">VAT ID: <span className="profile-payments__billing-value">{`${vatId}${vatStatus}`}</span></Text>
            <Text className="">Billing country: <span className="profile-payments__billing-value">{billingAddress.address_country || 'Not provided'}</span></Text>
            <Text className="">Billing address: <span className="profile-payments__billing-value">{resolveBillingAddress(profile)}</span></Text>
          </div>
        )}
        {needsDetails && (
          <BillingDetailsCard
            className="profile-payments__invoice-billing-card"
            billingAddress={billingAddress}
            billingInfo={billingInfo}
            shippingAddress={profile?.auction_bidder_profile?.shipping_address ?? null}
            onSaved={onDetailsSaved}
          />
        )}
        <div className="profile-payments__invoice-actions">
          <ContinueButton loading={loading} turnOff={needsDetails} onClick={onConfirm}>
            {loading ? 'Updating...' : 'Confirm business billing'}
          </ContinueButton>
        </div>
      </div>
    </GenericPopup>
  );
}
